<script lang="ts" setup>
import useMounted from '@/utilities/useMounted'
import IconsRight from './fragments/IconsRight.vue'
import PrevNext from './fragments/PrevNext.vue'
import TopBar from './fragments/TopBar.vue'

defineProps<{
  location: string
  size: 'sm' | 'lg'
  purple?: boolean
}>()

const mounted = useMounted()
</script>

<template>
  <div data-cy="browser" class="transform rounded-lg bg-white outline outline-1 outline-gray-100">
    <TopBar :key="mounted ? size : 'unmounted'" :size="size" :purple="purple">
      <PrevNext class="hidden md:flex" :size="size" :purple="purple" />
      <div class="flex grow justify-center">
        <svg
          height="24"
          width="150"
          :viewBox="`0 0 ${size === 'lg' ? '150 24' : '90 16'}`"
          class="w-[75%] shrink overflow-hidden overflow-ellipsis whitespace-nowrap rounded px-[8px]"
          aria-hidden="true"
          :class="{
            'h-[16px]': size === 'sm',
            'h-[24px]': size === 'lg',
            'border border-gray-100 fill-gray-700': !purple,
            'bg-purple-600 fill-purple-300': purple,
          }"
        >
          <text
            x="50%"
            :y="size === 'lg' ? '16px' : '12px'"
            :font-size="size === 'lg' ? '14px' : '10px'"
            text-anchor="middle"
          >
            {{ location }}
          </text>
        </svg>
      </div>
      <IconsRight :size="size" :purple="purple" />
    </TopBar>
    <slot />
  </div>
</template>
